<!-- Youtube -->
<template>
    <div class="youtube-mask"
    :class="{'show': show }"
    v-if="isDisplay">
        <div class="youtube-container">
            <a href="" class="close-btn" @click.prevent="$parent.popup()">
                <img src="@/assets/images/popup/btn_popup_close@2x.png" alt="">
            </a>
            <iframe width="100%" height="100%" :src="`https://www.youtube.com/embed/${youtubeCode}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" v-if="youtubeCode"></iframe>
            <a href="" class="share-btn"
            @click.prevent="onShare();gaEvent('share_fb', 'video_share');">
                立即分享
            </a>
        </div>
    </div>
</template>

<script type="text/javascript">
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
            required: true,
        },
        youtube: {
            type: String,
        },
    },
    computed: {
        youtubeCode() {
            const url = this.youtube;
            const str = 'https://www.youtube.com/watch?v=';
            const code = url.split(str)[1];
            return code || '';
        },
    },
    data() {
        return {
            isDisplay: false,
        };
    },
    methods: {
        onShare() {
            this.$parent.onShare('fb', this.youtube);
        },
    },
    watch: {
        show(val) {
            if (!val) {
                window.setTimeout(() => {
                    this.isDisplay = val;
                }, 800);
            } else {
                this.isDisplay = val;
            }
        },
    },
    mixins: [mixinMethod],
};
</script>

<style lang="sass" scoped>

.youtube-mask
    background-color: rgba(#000, .9)
    width: 100vw
    height: 100vh
    top: 0
    left: 0
    position: fixed
    opacity: 0
    transition: .8s ease-in-out
    z-index: 10
    &.show
        opacity: 1

.youtube-container
    $s: 90vw
    position: absolute
    text-align: center
    top: 14vh
    left: calc(50% - 45vw)
    width: $s
    height: $s

.close-btn
    position: absolute
    right: .5em
    top: -2em
    z-index: 2

.share-btn
    background: url('../assets/images/popup/btn_popup_common@2x.png') no-repeat 50% / contain
    color: #f2e6af
    display: inline-block
    font-size: .8em
    padding: 1.5em 2em
    vertical-align: middle
    margin-top: 1em
    &:hover
        text-decoration: none

@media (min-width: 768px)
    .youtube-container
        $s: 74vw
        left: calc(50% - 37vw)
        width: $s
        height: $s * 0.6

@media (min-width: 1200px)
    .youtube-container
        $s: 46em
        left: calc(50% - 23em)
        width: $s
        height: $s * 0.6

</style>
